import { MAX_COLOR_SATURATION, MAX_COLOR_VALUE } from './consts';
import { hsv2hex } from './hsv2hex';
/**
 * Converts a color hue to an HTML color string (with # prefix).
 * This implementation ignores all components of `color` except hue.
 */
export function getFullColorString(color) {
    return "#" + hsv2hex(color.h, MAX_COLOR_SATURATION, MAX_COLOR_VALUE);
}
//# sourceMappingURL=getFullColorString.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/utilities/color/getFullColorString.js
// module id = 139
// module chunks = 0